var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoreference(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8638 31.6824C60.8638 41.5683 52.8491 49.583 42.9632 49.583C33.0772 49.583 25.0625 41.5683 25.0625 31.6824C25.0625 21.7965 33.0772 13.7817 42.9632 13.7817C52.8491 13.7817 60.8638 21.7965 60.8638 31.6824Z",
    fill: "#DEDEDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9609 0.078125C19.258 0.078125 0 19.2874 0 43.0391C0 66.742 19.2093 86 42.9609 86C66.7126 86 85.9219 66.7907 85.9219 43.0391C85.9219 19.3362 66.6634 0.078125 42.9609 0.078125ZM71.8988 69.7804V68.4718C71.8988 60.1264 65.1089 53.3119 56.7389 53.3119H28.8643C20.5188 53.3119 13.7043 60.1018 13.7043 68.4718V69.5335C7.35896 62.5461 3.48252 53.2625 3.48252 43.0405C3.48252 21.2882 21.1362 3.63496 42.888 3.63496C64.6398 3.63496 82.3184 21.2887 82.3184 43.0405C82.3677 53.3858 78.4419 62.7434 71.899 69.7796L71.8988 69.7804Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoreference);
export default __webpack_public_path__ + "static/media/noreference.76db9baa257dbce7d808d08ff95eb132.svg";
export { ForwardRef as ReactComponent };